var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"rowKey":(record, index) => {
          return index
        },"columns":_vm.columns,"loading":_vm.tableLoading,"pagination":_vm.pagination,"data-source":_vm.tableData,"customRow":_vm.customRow},on:{"change":_vm.handleChangeInTable},scopedSlots:_vm._u([{key:"name",fn:function(text){return _c('a',{},[_vm._v(_vm._s(text))])}},{key:"contractCode",fn:function(contractCode){return [_c('h1',{staticStyle:{"color":"var(--ThemeColor)"}},[_vm._v(_vm._s(contractCode))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }